export default {
  projectUrl: '/project',
  centerUrl: '/center',
  fileUrl: '/file',
  trainUrl: '/train',
  faceUrl: '/face',
  environmentUrl: '/environment',
  deviceServerUrl: '/device-server'
}



// WEBPACK FOOTER //
// ./src/api/requestPrefix.js